import { useEffect, useRef, useState } from "react";
import i18n, { _get_i18Lang } from "../i18n";
import { ISearchParams } from "../Services/SearchData";
import { Link, useNavigate, NavLink, useLocation } from "react-router-dom";
import "../Styles/style.css";
import arrowdown from "../assets/img/dropdown-whiteIcon.png";
import arrowdownblack from "../assets/img/dropdownblack.svg";
import { useTranslation } from "react-i18next";
import { LogInModel } from "../Pages/LoginModel";
import { LogOutModel } from "../Pages/LogOutModel";
import gitalogo from "../Images/logo_Main.png";
import $ from "jquery";
import Userimage from "../assets/img/userWhite.png";
import SearchIcon from "../assets/img/search-icons.png";
import ProfileIcon from "../assets/img/profile-icon1.png";
import ProfileFavourite from "../assets/img/profile-icon2.png";
import FeedbackIcon from "../assets/img/profile-icon4.png";
import LogoutIcon from "../assets/img/logout.png";
import IndianFlag from "../Images/flag-India.png";
import UKFlag from "../Images/flag-uk.png";
import ProfileService from "../Services/Profile";
import LoginServices from "../Services/Login";

const HeaderPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef: any = useRef(null);
  const [searchValue, setSearchValue] = useState<ISearchParams>({
    language: _get_i18Lang(),
    productType: "all",
    searchValue: "",
    authorId: "",
  });

  const [isOpened, setIsOpened] = useState<boolean>(false);

  const [showLang, setShowLang] = useState<boolean>(false);
  const [menu, setMenu] = useState<boolean>(false);

  const [audiosdropdown, setAudiosdropdown] = useState<boolean>(false);

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const [logIn, setLogIn] = useState<boolean>(false);
  const [loginState, setLoginState] = useState<boolean>(false);

  const [hoveredLang, setHoveredLang] = useState<any>(null);

  const UserIdentity = localStorage.getItem("UserId") as string;
  // const images = localStorage.getItem("Image") as any

  const [imgs, setImgs] = useState<any>("");
  // Initialize directly from window so react-snap Puppeteer viewport (1024px+)
  // renders the desktop nav instead of the mobile-only view (which has no nav links).
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1280
  );

  const closeModal = () => {
    setLogIn(false);
  };

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpened(false);
        setShowLang(false);
        setMenu(false);
        setAudiosdropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  function toggleLang() {
    setShowLang((wasOpened) => !wasOpened);
  }

  function togglemenu() {
    setMenu((wasOpened) => !wasOpened);
  }

  function toggle() {
    setIsOpened((wasOpened) => !wasOpened);
  }

  function toggleAudiodropdown() {
    setAudiosdropdown((wasOpened) => !wasOpened);
  }

  function changeLocale(l: string) {
    i18n.changeLanguage(l);
    localStorage.setItem("lan", _get_i18Lang());
    localStorage.setItem("locale", l);
    if (localStorage.getItem("locale") === "en") {
      $(".select-lang").removeClass("langwidth");
    } else {
      $(".select-lang").addClass("langwidth");
    }
  }

  const handleLoginStateChange = (newState: any) => {
    setLoginState(newState === true);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
  }, [])

  useEffect(() => {
    // Since App.tsx now handles the global auth check and token refresh on startup,
    // HeaderPage simply reads the existing profile data from localStorage.
    const userImage = localStorage.getItem("Image");
    setImgs(userImage || "");

    console.log("HeaderPage: Auth/Profile check skipped (handled by App). Loaded image from storage:", userImage);
  }, [UserIdentity]);

  const handleError = () => {
    setImgs("");
  };

  return (
    <div>
      {/*
       * SEO crawler nav — always rendered in the DOM (including react-snap pre-render).
       * Visually hidden via absolute off-screen positioning so it does not affect layout.
       * Ensures all primary section links appear in every pre-rendered HTML page
       * regardless of viewport width or dropdown open/closed state.
       */}
      <nav
        aria-label="SEO site navigation"
        style={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
          width: "1px",
          height: "1px",
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/books">Books</Link>
        <Link to="/magazines">Magazines</Link>
        <Link to="/magazines/geetgovind">Monthly Magazine</Link>
        <Link to="/magazines/kalyan">Kalyan</Link>
        <Link to="/magazines/kalyanakalpataru">Kalyana Kalpataru</Link>
        <Link to="/magazines/vivekvani">Vivek Vani</Link>
        <Link to="/audios">Audios</Link>
        <Link to="/pravachans">Pravachans</Link>
        <Link to="/DailySatsang">Daily Satsang</Link>
        <Link to="/videos">Videos</Link>
        <Link to="/divinequotes">Amrit Vachan</Link>
        <Link to="/articles">Articles</Link>
        <Link to="/faq">FAQ</Link>
        <Link to="/privacypolicy">Privacy Policy</Link>
        <Link to="/termsofuse">Terms of Use</Link>
        <Link to="/promotion">Promotion</Link>
      </nav>

      <div className="gst-header hideOnMobile" id="gstheader">

        <div className={windowWidth <= 768 ? "container" : "containers"}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <p className="shrihari" style={{ textAlign: "center" }}>
              {t("shrihari_tr")}
            </p>
          </div>
          {windowWidth <= 768 ? (
            <>
              <div
                className=""
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Link to="/">
                  <img src={gitalogo} alt="gstlogo" />
                </Link>
              </div>

              <div className="gst-menu" style={{ marginLeft: "60px" }}>
                <div
                  className="allCatSearch"
                  style={{
                    padding: "2px 10px 0 6px",
                    borderRadius: "4px",
                    width: "120px",
                    border: "none",
                    cursor: "pointer",
                    marginLeft: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    backgroundColor: "#FFA54F",
                    color: "#FFFFFF",

                  }}
                  onClick={toggleLang}
                >
                  {localStorage.getItem("locale") === "hi" ? (
                    <>
                      <img
                        src={IndianFlag}
                        alt=""
                        style={{ margin: "0 8px 0 2px", borderRadius: "5px" }}
                      />{" "}
                      हिन्दी
                    </>
                  ) : (
                    <>
                      <img
                        src={UKFlag}
                        alt=""
                        style={{ margin: "0 8px 0 2px", borderRadius: "5px" }}
                      />{" "}
                      English
                    </>
                  )}
                  <img
                    src={arrowdown}
                    alt="arrowdown"
                    style={{
                      width: "25px",
                      filter: "drop-shadow(0 0 2px white)",
                    }}
                  />
                </div>
                <div>
                  {showLang && (
                    <div
                      ref={dropdownRef}
                      className="dropdownstyle"
                      style={{
                        position: "absolute",
                        zIndex: 1,
                        left: '60%'

                      }}
                    >
                      <div
                        className="activelang"
                        style={{
                          margin: "25px 0 0 0",
                          border: "1px solid gray",
                          textAlign: "center",
                          width: "110px",
                          backgroundColor:
                            hoveredLang === "हिन्दी" ? "#A13316" : "#FDEBCB", // lighter on hover
                          cursor: "pointer",
                          display: "flex",
                        }}
                        onClick={() => {
                          setShowLang(false);
                          changeLocale("hi");
                          setSearchValue({
                            ...searchValue,
                            language: "हिन्दी",
                          });
                        }}
                        onMouseEnter={() => setHoveredLang("हिन्दी")}
                        onMouseLeave={() => setHoveredLang(null)}
                      >
                        <img
                          src={IndianFlag}
                          style={{
                            width: "30%",
                            margin: "0 5px",
                            borderRadius: "5px",
                          }}
                          alt="india-flag"
                        />
                        <p
                          style={{
                            color:
                              hoveredLang === "हिन्दी" ? "#fff" : "#822F1A",
                          }}
                        >
                          हिन्दी
                        </p>
                      </div>
                      <div
                        className="activelang"
                        style={{
                          marginTop: "-4px",
                          border: "1px solid gray",
                          textAlign: "center",
                          backgroundColor:
                            hoveredLang === "English" ? "#A13316" : "#FDEBCB", // lighter on hover
                          cursor: "pointer",
                          width: "110px",
                          display: "flex",
                        }}
                        onClick={() => {
                          setShowLang(false);
                          changeLocale("en");
                          setSearchValue({
                            ...searchValue,
                            language: "English",
                          });
                        }}
                        onMouseEnter={() => setHoveredLang("English")}
                        onMouseLeave={() => setHoveredLang(null)}
                      >
                        <img
                          src={UKFlag}
                          style={{
                            width: "30%",
                            margin: "0 5px",
                            borderRadius: "5px",
                          }}
                          alt="india-flag"
                        />
                        <p
                          style={{
                            color:
                              hoveredLang === "English" ? "#fff" : "#822F1A",
                          }}
                        >
                          English
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className="row">
              <div className="logo-width">
                <div
                  className="gst-logo"
                // style={{ float: "none", width: "55%" }}
                >
                  <Link to="/">
                    <img src={gitalogo} alt="gstlogo" />
                  </Link>
                </div>
              </div>

              <div className="headerwidth">
                <div
                  style={{
                    display: "flex",
                    float: "right",
                    paddingTop: "15px",
                    marginRight: "3px",
                  }}
                >
                  <div className="gst-menu">
                    <select
                      className="allCatSearch"
                      // style={{ width: "95px" }}
                      onChange={(e) => {
                        searchValue.productType =
                          e.currentTarget?.value ?? undefined;
                      }}
                    >
                      <option value="all" style={{ color: "#000" }}>
                        {t("all_tr")}
                      </option>
                      <option value="book" style={{ color: "#000" }}>
                        {t("E_books_tr")}
                      </option>
                      <option value="monthlymagazine" style={{ color: "#000" }}>
                        {t("MonthlyMagazine_tr")}
                      </option>
                      <option value="kalyan" style={{ color: "#000" }}>
                        {t("Kalyan_tr")}
                      </option>
                      <option value="kalpataru" style={{ color: "#000" }}>
                        {t("Kalpataru_tr")}
                      </option>
                      <option value="audio" style={{ color: "#000" }}>
                        {t("Audios_tr")}
                      </option>
                      <option value="pravachan" style={{ color: "#000" }}>
                        {t("Pravachan_tr")}
                      </option>
                       <option value="amritvachan" style={{ color: "#000" }}>
                        {t("AmritVachan_tr")}
                      </option>
                      <option value="article" style={{ color: "#000" }}>
                        {t("Article_tr")}
                      </option>
                      <option value="vivekvani" style={{ color: "#000" }}>
                        {t("vivek_vani_tr")}
                      </option>
                      <option value="video" style={{ color: "#000" }}>
                        {t("Video_tr")}
                      </option>
                    </select>
                  </div>
                  <div className="searchbar" style={{ marginRight: "5px" }}>
                    <div style={{ display: "flex" }}>
                      <input
                        type="search"
                        name="search"
                        maxLength={50}
                        className="red-input"
                        value={searchValue.searchValue}
                        style={{
                          width: windowWidth <= 1400 ? "225px" : "232px",
                          padding: "3px 50px 3px 15px",
                          border: "none",
                        }}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Check if input matches DD/MM/YYYY format
                          const isDateFormat = /^\d{2}\/\d{2}\/\d{4}$/.test(value);

                          const finalValue = isDateFormat
                            ? value.replaceAll("/", "-") // Convert to DD-MM-YYYY
                            : value; // Keep original if not a date
                          setSearchValue({
                            ...searchValue,
                            searchValue: finalValue,
                          });
                        }}
                        onKeyDown={(e: any) => {
                          if (e.key === "Enter") {
                            if (searchValue?.searchValue?.length > 0) {
                              e.preventDefault();
                              navigate(`/searchdata/` + searchValue?.productType + "/" + searchValue?.searchValue, {
                                state: {
                                  product: searchValue?.productType,
                                  searchtext: searchValue?.searchValue,
                                  author: searchValue?.authorId
                                }
                              })
                            }
                          }
                        }}
                      />
                      <img
                        style={{
                          width: "27px",
                          padding: "7px 10px 0 0",
                          backgroundColor: "transparent",
                          border: "none",
                          outline: "none",
                          position: "absolute",
                          right: "-35px",
                          cursor: "pointer",
                        }}
                        src={SearchIcon}
                        alt="search"
                        onClick={() => {
                          if (searchValue?.searchValue?.length > 0) {
                            navigate(`/searchdata/` + searchValue?.productType + "/" + searchValue?.searchValue, {
                              state: {
                                product: searchValue?.productType,
                                searchtext: searchValue?.searchValue,
                                author: searchValue?.authorId
                              }
                            })
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="gst-menu" style={{ marginLeft: "17px" }}>
                    <div
                      className="allCatSearch"
                      style={{
                        padding: "2px 10px 0 6px",
                        borderRadius: "4px",
                        width: "130px",
                        border: "none",
                        cursor: "pointer",
                        marginLeft: "12px",
                        display: "flex",
                        justifyContent: "space-between",
                        backgroundColor: "#A13316",
                        color: "#FFFFFF",
                      }}
                      onClick={toggleLang}
                    >
                      {localStorage.getItem("locale") === "hi" ? (
                        <>
                          <img
                            src={IndianFlag}
                            alt=""
                            style={{
                              margin: "0 8px 0 2px",
                              borderRadius: "5px",
                            }}
                          />{" "}
                          हिन्दी
                        </>
                      ) : (
                        <>
                          <img
                            src={UKFlag}
                            alt=""
                            style={{
                              margin: "0 8px 0 2px",
                              borderRadius: "5px",
                            }}
                          />{" "}
                          English
                        </>
                      )}
                      <img
                        src={arrowdown}
                        alt="arrowdown"
                        style={{
                          width: "25px",
                          filter: "drop-shadow(0 0 2px white)",
                        }}
                      />
                    </div>
                    <div>
                      {showLang && (
                        <div
                          ref={dropdownRef}
                          className="dropdownstyle"
                          style={{
                            position: "absolute",
                            zIndex: 1,
                            margin: "5px 0 0 35px",
                          }}
                        >
                          <div
                            className="activelang"
                            style={{
                              margin: "25px 0 0 0",
                              border: "1px solid gray",
                              textAlign: "center",
                              width: "110px",
                              backgroundColor:
                                hoveredLang === "हिन्दी"
                                  ? "#A13316"
                                  : "#FDEBCB", // lighter on hover
                              cursor: "pointer",
                              display: "flex",
                            }}
                            onClick={() => {
                              setShowLang(false);
                              changeLocale("hi");
                              setSearchValue({
                                ...searchValue,
                                language: "हिन्दी",
                              });
                            }}
                            onMouseEnter={() => setHoveredLang("हिन्दी")}
                            onMouseLeave={() => setHoveredLang(null)}
                          >
                            <img
                              src={IndianFlag}
                              style={{
                                width: "30%",
                                margin: "0 5px",
                                borderRadius: "5px",
                              }}
                              alt="india-flag"
                            />
                            <p
                              style={{
                                color:
                                  hoveredLang === "हिन्दी" ? "#fff" : "#822F1A",
                              }}
                            >
                              हिन्दी
                            </p>
                          </div>
                          <div
                            className="activelang"
                            style={{
                              marginTop: "-4px",
                              border: "1px solid gray",
                              textAlign: "center",
                              backgroundColor:
                                hoveredLang === "English"
                                  ? "#A13316"
                                  : "#FDEBCB", // lighter on hover
                              cursor: "pointer",
                              width: "110px",
                              display: "flex",
                            }}
                            onClick={() => {
                              setShowLang(false);
                              changeLocale("en");
                              setSearchValue({
                                ...searchValue,
                                language: "English",
                              });
                            }}
                            onMouseEnter={() => setHoveredLang("English")}
                            onMouseLeave={() => setHoveredLang(null)}
                          >
                            <img
                              src={UKFlag}
                              style={{
                                width: "30%",
                                margin: "0 5px",
                                borderRadius: "5px",
                              }}
                              alt="india-flag"
                            />
                            <p
                              style={{
                                color:
                                  hoveredLang === "English"
                                    ? "#fff"
                                    : "#822F1A",
                              }}
                            >
                              English
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="gst-menubar">
                  <ul
                    className="list-unstyled hmenu"
                    style={{ display: "flex", gap: 13 }}
                  >
                    <>
                      <li>
                        <Link
                          id="hmenu_home"
                          to="/"
                          onClick={() => {
                            setMenu(false);
                            setAudiosdropdown(false)
                          }}
                          style={{
                            color:
                              window?.location.pathname === "/"
                                ? "#d11501"
                                : "#472d1e",
                          }}
                        >
                          <i
                            className="fa fa-home"
                            style={{ fontSize: "22px" }}
                          ></i>
                        </Link>
                      </li>
                      <li>
                        <NavLink
                          id="hmenu_about"
                          to="/about"
                          onClick={() => {
                            setMenu(false);
                            setAudiosdropdown(false)
                          }}
                          style={({ isActive }) => {
                            return { color: isActive ? "#d11501" : "#472d1e" };
                          }}
                        >
                          {t("Introduction_tr")}
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          id="hmenu_books"
                          to="/books"
                          onClick={() => {
                            setMenu(false);
                            setAudiosdropdown(false)
                          }}
                          style={({ isActive }) => {
                            return { color: isActive ? "#d11501" : "#472d1e" };
                          }}
                        >
                          {t("E_books_tr")}
                        </NavLink>
                      </li>

                      <li>
                        <div style={{ display: "inline-block" }}>
                          <div
                            className="menubar-deopdown-menu"
                            style={{ display: "flex", alignItems: "center", gap: "4px", cursor: "pointer" }}
                          >
                            <span
                              id="hmenu_magazines"
                              onClick={() => {
                                navigate("/magazines");
                                setMenu(false);
                                setAudiosdropdown(false);
                              }}
                              style={{
                                color: location.pathname.includes("/magazines") ? "#d11501" : "#472d1e",
                              }}
                            >
                              {t("magazine_tr")}
                            </span>
                            <img
                              src={arrowdownblack}
                              alt="arrowdownblack"
                              className="dropdown-icon"
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                togglemenu();
                                setAudiosdropdown(false);
                              }}
                            />
                          </div>
                          <div>
                            {menu && (
                              <div
                                ref={dropdownRef}
                                style={{
                                  display: "grid",
                                  position: "absolute",
                                  padding: "10px 9px 0px",
                                  zIndex: 1,
                                  background: "#FDA63B",
                                  borderRadius: "5px",
                                }}
                              >
                                <NavLink
                                  id="hmenu_Kalpataru"
                                  to="/magazines/geetgovind"
                                  onClick={() => {
                                    setMenu(false);
                                  }}
                                  style={({ isActive }) => {
                                    return {
                                      color: isActive ? "#d11501" : "#472d1e",
                                      marginTop: "-10px",
                                    };
                                  }}
                                >
                                  {t("MonthlyMagazine_tr")}
                                </NavLink>
                                <NavLink
                                  id="menu_klayan"
                                  to="/magazines/kalyan"
                                  onClick={() => {
                                    setMenu(false);
                                  }}
                                  style={({ isActive }) => {
                                    return {
                                      color: isActive ? "#d11501" : "#472d1e",
                                      marginTop: "-10px",
                                    };
                                  }}
                                >
                                  {t("Kalyan_tr")}
                                </NavLink>
                                <NavLink
                                  id="menu_Kalpataru"
                                  to="/magazines/kalyanakalpataru"
                                  onClick={() => {
                                    setMenu(false);
                                  }}
                                  style={({ isActive }) => {
                                    return {
                                      color: isActive ? "#d11501" : "#472d1e",
                                      marginTop: "-10px",
                                    };
                                  }}
                                >
                                  {t("Kalpataru_tr")}
                                </NavLink>
                                <NavLink
                                  id="menu_vivek"
                                  to="/magazines/vivekvani"
                                  onClick={() => {
                                    setMenu(false);
                                  }}
                                  style={({ isActive }) => {
                                    return {
                                      color: isActive ? "#d11501" : "#472d1e",
                                      marginTop: "-10px",
                                    };
                                  }}
                                >
                                  {t("vivek_vani_tr")}
                                </NavLink>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div style={{ display: "inline-block" }}>
                          <div
                            id="hmenu_audios"
                            className="menubar-deopdown-menu"
                            onClick={() => {
                              setMenu(false)
                              toggleAudiodropdown()
                            }}
                            style={{
                              color: location.pathname === "/audios" || location.pathname === "/pravachans" || location.pathname === "/DailySatsang" ? "#d11501" : "#472d1e",
                            }}
                          >
                            {t("Audios_tr")}
                            <img
                              src={arrowdownblack}
                              alt="arrowdownblack"
                              className="dropdown-icon"
                            />
                          </div>
                          <div>
                            {audiosdropdown && (
                              <div
                                ref={dropdownRef}
                                style={{
                                  display: "grid",
                                  position: "absolute",
                                  padding: "10px 9px 0px",
                                  zIndex: 1,
                                  background: "#FDA63B",
                                  borderRadius: "5px",
                                }}
                              >
                                <NavLink
                                  id="hmenu_audios"
                                  to="/audios"
                                  style={({ isActive }) => {
                                    return {
                                      color: isActive ? "#d11501" : "#472d1e",
                                      marginTop: "-10px",
                                    };
                                  }}
                                  onClick={() => {
                                    localStorage.setItem("type", "audios");
                                    setAudiosdropdown(false);
                                    setMenu(false);
                                  }}
                                >
                                  {t("Audios_tr")}
                                </NavLink>
                                <NavLink
                                  id="hmenu_pravachans"
                                  to="/pravachans"
                                  style={({ isActive }) => {
                                    return {
                                      color: isActive ? "#d11501" : "#472d1e",
                                      marginTop: "-10px",
                                    };
                                  }}
                                  onClick={() => {
                                    localStorage.setItem("type", "pravachans");
                                    setAudiosdropdown(false);
                                  }}
                                >
                                  {t("Pravachan_tr")}
                                </NavLink>
                                <NavLink
                                  id="hmenu_satsang"
                                  to="/DailySatsang"
                                  style={({ isActive }) => {
                                    return {
                                      color: isActive ? "#d11501" : "#472d1e",
                                      marginTop: "-10px",
                                    };
                                  }}
                                  onClick={() => {
                                    localStorage.setItem(
                                      "type",
                                      "DailySatsang"
                                    );
                                    setAudiosdropdown(false);
                                  }}
                                >
                                  {t("daily_satsang_tr")}
                                </NavLink>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>

                      <li>
                        <div style={{ display: "inline-block" }}>
                          <NavLink
                            id="hmenu_about"
                            to="/videos"
                            onClick={() => {
                              setMenu(false);
                              setAudiosdropdown(false)
                            }}
                            style={({ isActive }) => {
                              return {
                                color: isActive ? "#d11501" : "#472d1e",
                              };
                            }}
                          >
                            {t("Video_tr")}
                          </NavLink>
                        </div>
                      </li>
                      <li>
                        <NavLink
                          id="menu_vivek"
                          to="/divinequotes"
                          style={({ isActive }) => {
                            return {
                              color: isActive ? "#d11501" : "#472d1e",
                              marginTop: "-10px",
                            };
                          }}
                          onClick={() => {
                            setMenu(false)
                            setAudiosdropdown(false)
                          }}
                        >
                          {t("Amrit_Vachan_tr")}
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          id="hmenu_articles"
                          to="/articles"
                          onClick={() => {
                            setMenu(false);
                            setAudiosdropdown(false);
                          }}
                          style={({ isActive }) => {
                            return {
                              color: isActive ? "#d11501" : "#472d1e",
                              marginTop: "-10px",
                            };
                          }}
                        >
                          {t("Article_tr")}
                        </NavLink>
                      </li>
                    </>
                  </ul>

                  <div className="loginmenudd">
                    <a
                      className="link-btn"
                      style={{
                        cursor: "pointer",
                        margin: "15px 0 0 0",
                      }}
                    >
                      {UserIdentity ? (
                        <img
                          id="userimg"
                          src={imgs === "" ? Userimage : imgs}
                          onError={handleError}
                          title="User Login"
                          className="nousericon"
                          alt="user"
                          onClick={toggle}
                          style={{ width: "40px", height: "40px" }}
                        />
                      ) : (
                        <img
                          id="userimg"
                          src={Userimage}
                          title="User Login"
                          className="nousericon"
                          alt="user"
                          onClick={() => {
                            setLogIn(true);
                          }}
                          style={{ width: "40px", height: "40px" }}
                        />
                      )}
                    </a>
                    {isOpened && (
                      <div
                        ref={dropdownRef}
                        style={{
                          position: "absolute",
                          backgroundColor: "#ffffff",
                          padding: "10px 5px",
                          left: "15px",
                          top: "56px",
                          width: "146px",
                          borderRadius: "5px",
                          display: "grid",
                          zIndex: 9999,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            fontSize: "22px",
                            marginBottom: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate(`/profile`);
                            setIsOpened(false);
                          }}
                        >
                          <img
                            src={ProfileIcon}
                            alt="favourite"
                            style={{
                              display: "flex",
                              width: "22px",
                              height: "25px",
                              margin: "0 12px",
                            }}
                          />
                          <p
                            style={{
                              fontFamily: "Roboto,Helvetica Neue,sans-serif",
                              fontSize: "14px",
                              color: "#000000de",
                              marginTop: "3px",
                            }}
                          >
                            {t("Profile_tr")}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontSize: "22px",
                            marginBottom: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setIsOpened(false);
                            navigate(`/profile/My-Favourites`);
                          }}
                        >
                          <img
                            src={ProfileFavourite}
                            alt="feedback"
                            style={{
                              display: "flex",
                              width: "22px",
                              height: "25px",
                              margin: "0 12px",
                            }}
                          />
                          <p
                            style={{
                              fontFamily: "Roboto,Helvetica Neue,sans-serif",
                              fontSize: "14px",
                              color: "#000000de",
                              marginTop: "3px",
                            }}
                          >
                            {t("Favourite_tr")}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontSize: "22px",
                            marginBottom: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setIsOpened(false);
                            navigate(`/profile/feedback`);
                          }}
                        >
                          <img
                            src={FeedbackIcon}
                            alt="profile"
                            style={{
                              display: "flex",
                              width: "22px",
                              height: "25px",
                              margin: "0 12px",
                            }}
                          />
                          <p
                            style={{
                              fontFamily: "Roboto,Helvetica Neue,sans-serif",
                              fontSize: "14px",
                              color: "#000000de",
                              marginTop: "3px",
                            }}
                          >
                            {t("Help_tr")}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            fontSize: "22px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setIsDialogOpen(true);
                            setIsOpened(false);
                          }}
                        >
                          <img
                            src={LogoutIcon}
                            alt="logout"
                            style={{
                              display: "flex",
                              width: "22px",
                              height: "25px",
                              margin: "0 12px",
                            }}
                          />
                          <p
                            style={{
                              fontFamily: "Roboto,Helvetica Neue,sans-serif",
                              fontSize: "14px",
                              color: "#000000de",
                              marginTop: "3px",
                            }}
                          >
                            {t("LogOut_tr")}
                          </p>
                        </div>
                      </div>
                    )}
                    <LogOutModel
                      open={isDialogOpen}
                      onClose={handleCloseDialog}
                    />
                  </div>
                  <LogInModel
                    opens={logIn}
                    onCloses={closeModal}
                    onLoginStateChange={handleLoginStateChange}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default HeaderPage;
